<div class="flex-direction-column gap-15 margin-bottom-15">
  @if (visualizar) {
    <div class="flex-direction-column gap-5 width-100">
      <span class="label">Titulo</span>
      <span class="font-12">{{ template.nome }}</span>
    </div>
    @if (!isSms) {
      <div class="flex-direction-column gap-5 width-100">
        <span class="label">Idioma</span>
        <span class="font-12">{{ template.idioma }}</span>
      </div>
    }
  }
  @else {
    <app-slide-toggle-padrao [valor]="template.ativo" (changeValue)="template.ativo = $event; alteracaoService.camposAlterado()"></app-slide-toggle-padrao>
    <app-form-field
      label="Titulo"
      heightFormField="35px"
      [placeholder]="isSms ? 'Digite um título para o template' : 'apenas letras minusculas e “_” para separar. Ex.: ola_usuario'"
      [value]="template.nome"
      (changeValue)="receberTitulo($event); alteracaoService.camposAlterado()">
    </app-form-field>
    @if (!isSms) {
      <app-select-one
        class="width-100"
        heightFormField="36px"
        placeholder="Selecione o idioma"
        [listaInput]="listaIdiomas"
        chaveCompare="value"
        [itemSelecionado]="template.idioma"
        [font]="'12px'"
        (selecionarItem)="settarIdioma($event); alteracaoService.camposAlterado()"
        label="Idioma"
        campo="value"
        colorLabel="black"
      ></app-select-one>
    }
  }
</div>

@if (!isSms) {
<div class="container-titulo-secao-expand cursor-pointer" style="margin-bottom: 11px;" role="button" tabindex="0" (click)="cabecalhoExibido = !cabecalhoExibido" (keydown.enter)="cabecalhoExibido = !cabecalhoExibido">
  <span class="label">Cabeçalho (Opcional)</span>
  <mat-icon>{{ cabecalhoExibido ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
</div>

@if (cabecalhoExibido) {
  <div class="flex-direction-column gap-15">
    @if (visualizar) {
      @if (template.templateCabecalho.textoOuMidia === TextoMidiaEnum.TEXTO) {
        <div class="flex-direction-column gap-5 width-100">
          <span class="label">Texto</span>
          <span class="font-12" >{{ template.templateCabecalho.titulo }}</span>
        </div>
      }
      @else {
        <div class="flex-direction-column gap-5 width-100">
          <span class="label">Texto</span>
          @switch (template.templateCabecalho.format){
            @case ('IMAGE'){
              <img
                width="95%"
                height="60%"
                [src]="template.templateCabecalho.file"
                alt="Cabeçalho do template"
              >
            }
            @case ('VIDEO'){
              <video width="95%" height="60%" controls [src]="template.templateCabecalho.file" style="border: none;">
                Seu navegador não suporta a tag de vídeo.
              </video>
            }
            @case ('DOCUMENT'){
              <iframe
                [src]="template.templateCabecalho.file"
                width="95%"
                height="60%"
                style="border: 1px solid #ccc;">
              </iframe>
            }
            @case ('MAP'){
              <iframe
                [src]="template.templateCabecalho.file"
                width="95%"
                height="60%"
                style="border: 1px solid #ccc;">
              </iframe>
            }
          }
        </div>
      }
    }
    @else {
      <div class="flex gap-10 wrap">
        <app-slide-toggle-padrao
          [labelTrue]="'Texto'"
          [labelFalse]="'Mídia (vídeo, imagem, documento e localização)'"
          [fontSize]="'10px'"
          [valor]="template.templateCabecalho.textoOuMidia === TextoMidiaEnum.TEXTO"
          (changeValue)="$event ? template.templateCabecalho.textoOuMidia = TextoMidiaEnum.TEXTO : template.templateCabecalho.textoOuMidia = TextoMidiaEnum.MIDIA; alteracaoService.camposAlterado()">
        </app-slide-toggle-padrao>

        <app-button-padrao
          [icon]="'close'"
          width="18px"
          height="18px"
          (buttonClick)="limparCabecalho()"
        >
        </app-button-padrao>
      </div>
      @if (template.templateCabecalho.textoOuMidia === TextoMidiaEnum.TEXTO){
        <app-form-field
          label="Título"
          heightFormField="35px"
          [placeholder]="'Digite seu texto'"
          [value]="template.templateCabecalho.titulo"
          (changeValue)="template.templateCabecalho.titulo = $event; alteracaoService.camposAlterado()">
        </app-form-field>
      }
      @else {
        <app-template-midia-escolha (envioFormato)="template.templateCabecalho.format = $event" (envioArquivo)="buscarArquivoCabecalho($event); alteracaoService.camposAlterado()">
        </app-template-midia-escolha>
      }
    }
  </div>
}

}

<div class="label-lateral alteracao-padding" style="margin-bottom: 11px; height: 24px;">
  <span class="label">Corpo (obrigatório)</span>
</div>

<div class="flex-direction-column gap-15">
  @if (visualizar){
    <div class="flex-direction-column gap-5 width-100">
      <span class="label">Corpo</span>
      <span class="font-12">{{ template.variavel.corpo }}</span>
    </div>
  }
  @else {
<!--    <textarea-->
<!--      [ngModel]="template.variavel.corpo"-->
<!--      (ngModelChange)="pegarCorpoVariavel($event)"-->
<!--      (keydown)="bloquearChaves($event)"-->
<!--      rows="4"-->
<!--      placeholder=''-->
<!--    ></textarea>-->
    <div
      contenteditable="true"
      #editor
      (input)="onInputEditor(); alteracaoService.camposAlterado()"
      (keydown)="bloquearChaves($event)"
      class="editor"
      placeholder=""
      rows="4"
    ></div>

    @if (isSms) {
      <div class="contador-sms" [class.contador-sms--excedido]="calculoSms.sms > 1">
        <span>{{ calculoSms.caracteres }} caracteres · {{ calculoSms.sms }} SMS</span>
        @if (calculoSms.sms > 1) {
          <span>
            Este SMS custará {{ calculoSms.sms }}x o valor unitário pois ultrapassou o máx. de caracteres.
          </span>
        }
      </div>
    }



    <div class="flex width-100 justify-between align-center">
      @if (!isSms) {
        <div class="flex gap-10 align-center">
          <app-slide-toggle-padrao
            [labelTrue]="'Variável fixa'"
            [labelFalse]="'Variável livre'"
            [fontSize]="'12px'"
            [valor]="!!template.variavelFixa"
            (changeValue)="alterarVariavelFixa($event)">
          </app-slide-toggle-padrao>
        </div>
      } @else {
        <span></span>
      }
      <app-button-padrao
        width="138px"
        label="Add variável"
        [fontSize]="'12px'"
        [height]="'25px'"
        backgroundColor="var(--primary)"
        color="white"
        (buttonClick)="adicionarViariavel(); alteracaoService.camposAlterado()">
      </app-button-padrao>
    </div>

    <!-- @if (template.variavelFixa) {
      <span class="font-12" style="color: var(--primary);">
        Variável fixa: o valor é preenchido sozinho (nome/número do contato, nome do operador) na hora do envio — só disponível para lembretes, não aparece no chat nem em disparos.
      </span>
    } -->

    @if (template.variavel.variaveis.length > 0) {
      <div class="flex-direction-column gap-5">
        <span class="font-12 weight-700">Ex. De variáveis*</span>
        <div class="flex-direction-column gap-5" style="padding-left: 20px;">
          @for (variavel of template.variavel.variaveis; track variavel.numero) {
            <div class="flex gap-15 align-center">
              <span class="font-12" style="color: var(--primary); margin-top: 7%;">{{ variavel.numero }}</span>
              @if (template.variavelFixa) {
                <app-select-one
                  label="Preencher com"
                  heightFormField="35px"
                  [listaInput]="opcoesTipoVariavelFixa"
                  chaveCompare="valor"
                  [itemSelecionado]="opcaoTipoVariavelFixa(variavel)"
                  [font]="'12px'"
                  campo="label"
                  colorLabel="black"
                  (selecionarItem)="definirTipoVariavelFixa(variavel, $event); alteracaoService.camposAlterado()">
                </app-select-one>
              } @else {
                <app-form-field
                  label="Nome"
                  heightFormField="35px"
                  [value]="variavel.variavel"
                  (changeValue)="receberExemploVariavel($event, variavel); alteracaoService.camposAlterado()">
                </app-form-field>
              }
            </div>
          }
        </div>
      </div>
    }
  }
</div>

@if (!isSms) {
<div class="container-titulo-secao-expand cursor-pointer" style="margin-bottom: 11px;" role="button" tabindex="0" (click)="rodapeExibido = !rodapeExibido" (keydown.enter)="rodapeExibido = !rodapeExibido">
  <span class="label">Rodapé (Opcional)</span>
  <mat-icon>{{ rodapeExibido ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
</div>

@if (rodapeExibido){
  <div class="flex-direction-column gap-15">
    @if (visualizar){
      <div class="flex-direction-column gap-5 width-100">
        <span class="label">Texto</span>
        <span class="font-12">{{ template.textoRodape ?? '--' }}</span>
      </div>
    }
    @else {
      <div class="flex gap-10 align-center wrap">
        <app-form-field
          label="Texto"
          heightFormField="35px"
          [value]="template.textoRodape"
          (changeValue)="template.textoRodape = $event; alteracaoService.camposAlterado()">
        </app-form-field>

        <app-button-padrao
          [icon]="'close'"
          width="18px"
          height="18px"
          (buttonClick)="limparRodape(); alteracaoService.camposAlterado()"
          style="margin-top: 18px;"
        >
        </app-button-padrao>
      </div>
    }
  </div>
}

<div class="container-titulo-secao-expand cursor-pointer" style="margin-bottom: 11px;" role="button" tabindex="0" (click)="botaoExibido = !botaoExibido" (keydown.enter)="botaoExibido = !botaoExibido">
  <span class="label">Botão (Opcional)</span>
  <mat-icon>{{ botaoExibido ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
</div>

@if (botaoExibido){
  <div class="flex-direction-column gap-15">
    @if (visualizar){
      @for (btn of template.botoes; track btn.id) {
        <app-button-padrao
          width="75%"
          [height]="'20px'"
          [label]="btn.text!"
          backgroundColor="var(--primary)"
          color="white"
          [fontSize]="'12px'">
        </app-button-padrao>
      }
    }
    @else {
      <app-button-padrao
        width="80px"
        [height]="'20px'"
        label="Add Botão"
        backgroundColor="var(--primary)"
        color="white"
        [fontSize]="'12px'"
        (buttonClick)="adicionarBotao(); alteracaoService.camposAlterado()">
      </app-button-padrao>

      @if (template.botoes.length > 0){
        <div class="flex-direction-column gap-15">
          @for (btn of template.botoes; track btn; let index = $index) {
            <div class="flex-direction-column gap-15">

              <div class="flex gap-10 align-center wrap">
                <mat-button-toggle-group class="toggle-button" appearance="standard" name="fontStyle" aria-label="Font Style" [(ngModel)]="btn.type">
                  <div class="flex align-center gap-5">
                    <mat-button-toggle class="circle-toggle" [value]="'QUICK_REPLY'"></mat-button-toggle>
                    <span class="font-12 weight-400">Resposta</span>
                  </div>
                  <div class="flex align-center gap-5">
                    <mat-button-toggle class="circle-toggle" [value]="'URL'"></mat-button-toggle>
                    <span class="font-12 weight-400">Link</span>
                  </div>
                  <div class="flex align-center gap-5">
                    <mat-button-toggle class="circle-toggle" [value]="'PHONE_NUMBER'"></mat-button-toggle>
                    <span class="font-12 weight-400">Telefone</span>
                  </div>
                </mat-button-toggle-group>

                <app-button-padrao
                  [icon]="'close'"
                  width="18px"
                  height="18px"
                  (buttonClick)="limparBotao(index); alteracaoService.camposAlterado()"
                ></app-button-padrao>
              </div>

              <div class="flex-direction-column gap-5">
                <app-form-field
                  [label]="'Titulo'"
                  [maxLengthFormFiles]="20"
                  heightFormField="35px"
                  [placeholder]="'digite o titulo'"
                  [value]="btn.text"
                  (changeValue)="pegarConteudoBotao($event, btn); alteracaoService.camposAlterado()">
                </app-form-field>

                @if (btn.type === 'URL') {
                  <app-form-field
                    [label]="'URL'"
                    [placeholder]="criarPlaceholder(btn)"
                    heightFormField="35px"
                    [value]="btn.payload || btn.url"
                    (changeValue)="btn.payload = $event; verificarInteracaoBotaoUrl($event)">
                  </app-form-field>
                }
                @if (btn.type === 'PHONE_NUMBER') {
                  <app-form-field
                    [label]="'Número Telefone'"
                    mask="(00) 00000-0000"
                    [placeholder]="criarPlaceholder(btn)"
                    heightFormField="35px"
                    [value]="btn.payload || btn.phone_number"
                    (changeValue)="btn.payload = $event; verificarInteracaoBotaoPhone($event)">
                  </app-form-field>
                }
              </div>
            </div>
          }
          @if (conteudoBotaoMaisVinteCaracteres) {
            <span class="font-12" style="color: #c0392b">O Conteúdo não pode passar de 20 caracteres</span>
          }
          <div class="flex gap-5 align-center">
            <img src="./assets/icones/lampada.svg" style="width: 18px; height: 18px;" alt="">
            <span class="font-12 weight-400">Dica: Ao criar mais de 3 botões, eles aparecerão em uma lista.</span>
          </div>
        </div>
      }
    }
  </div>
}
@if (template.variavel.corpo) {
  <div>
    <app-prototipo-template [template]="template" [texto]="montarTextoMensagem()"></app-prototipo-template>
  </div>
}

<div class="label-lateral alteracao-padding" style="margin-bottom: 11px; height: 24px;">
  <span class="label">Número (obrigatório)</span>
</div>

<div class="flex-direction-column gap-15">
  @if (visualizar){
    <div class="flex-direction-column gap-5 width-100">
      <span class="label">Número</span>
      <span class="font-12">{{ template.conta.nome }} - {{ template.conta.numero | celularMask }}</span>
    </div>
  } @else {
    <app-select-one
      label="Número"
      widthFormField="100%"
      heightFormField="35px"
      [listaInput]="contas"
      [itemSelecionado]="template.conta"
      (selecionarItem)="template.conta = $event; alteracaoService.camposAlterado()"
      campo="nome"
      subCampo="numero"
    ></app-select-one>
    @if (contas.length === 0) {
      <span class="font-12">Nenhum número vinculado para o seu setor</span>
    }
  }
</div>
}
